import React from 'react';
import { Spinner } from 'reactstrap';

/**
 * Renders the preloader
 */
const Loader = () => {
    return (
        <div className="preloader">
            <div className="status">
                <div className="bouncing-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    );
};

export function ButtonLoader() {
    return (
        <Spinner size="sm" color="primary" />
    );
}

export function DataFetchLoader(props) {
    return (
        <div className='page-loading-loader-div w-100 h-100 d-flex justify-content-center align-items-center' style={{ minHeight: '300px' }}>
            <div>
                <h4>{props?.name}</h4>
                <div className="bouncing-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    ); 
}

export default Loader;
